var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIchodashia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_9857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0305 9.97884L14.7638 11.2818L15.1657 12.2893L18.5016 10.9588L17.6617 12.5013L18.6143 13.0197L20.4566 9.63674L16.7019 8.39758L16.3618 9.42797L18.0305 9.97884Z",
    fill: "#0ABD19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4758 16.4462L26.0394 15.453L15.6762 20.0096C15.0377 19.3633 14.1518 18.9619 13.1734 18.9619C12.9681 18.9619 12.7673 18.9805 12.5715 19.0144L5.40406 1.35609L1.91847 0L1.52539 1.01124L4.5745 2.19727L11.5424 19.3642C10.4213 19.9532 9.65448 21.1288 9.65448 22.4808C9.65448 24.4212 11.2331 26 13.1734 26C15.1143 26 16.6929 24.4212 16.6929 22.4808C16.6929 21.9168 16.5587 21.3838 16.3219 20.9108L26.4758 16.4462ZM13.1734 24.9151C11.8312 24.9151 10.7394 23.8231 10.7394 22.4808C10.7394 21.1387 11.8312 20.0467 13.1734 20.0467C14.5157 20.0467 15.6081 21.1387 15.6081 22.4808C15.608 23.8231 14.5157 24.9151 13.1734 24.9151Z",
    fill: "#0ABD19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.296 16.8449C14.781 17.9382 15.9806 17.8058 16.273 17.6249L23.556 14.4646C24.3162 14.1351 24.6664 13.2483 24.3369 12.488L21.0733 4.96563C20.8084 4.35431 20.0536 4.05399 19.4386 4.31993L11.9155 7.58372C11.1559 7.9135 10.8062 8.80026 11.1358 9.56042L14.296 16.8449ZM12.3477 8.5791L19.8708 5.31525C19.9697 5.27699 20.048 5.32884 20.0779 5.39713L23.3416 12.9195C23.4332 13.1311 23.3363 13.3776 23.1244 13.4693L15.8413 16.6296C15.6315 16.7192 15.3804 16.6177 15.2909 16.413L12.1311 9.12908C12.0394 8.91731 12.1364 8.67074 12.3477 8.5791Z",
    fill: "#0ABD19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_9857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.998047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIchodashia);
export default __webpack_public_path__ + "static/media/Ichodashia.ab8b54afb236164e91380eb70198edc0.svg";
export { ForwardRef as ReactComponent };